export default "__VITE_ASSET__CYAGdTNZ__"